module.exports = __webpack_public_path__ + "img/IMG_2368_L_Foamcore_MockedUp.a6f7b36a.jpg";